<div class="form-row">
  <div class="form-group col-md-6">
    <button
      mat-raised-button
      type="button"
      [disabled]="disabledConfirmar"
      (click)="confirmacaoDialog()"
      class="btn btn-azul btn-block"
      [attr.data-cy]="'button-confirmar-' + tipoOrdem"
    >
      {{ confirmacaoMessage }}
    </button>
  </div>
  <div class="form-group col-md-6">
    <button
      mat-raised-button
      type="button"
      (click)="cancelamentoDialog()"
      class="btn btn-branco btn-block"
      [attr.data-cy]="'button-cancelar-' + tipoOrdem"
    >
      Cancelar
    </button>
  </div>
</div>
